import {
  FaAd,
  FaCalendarAlt,
  FaFacebook,
  FaGoogle,
  FaDatabase,
  FaRegLightbulb,
} from "react-icons/fa";
import { LuImagePlus, LuLayoutDashboard } from "react-icons/lu";
import dashboardIcon from "../assets/images/dashboard_icon.svg";
import repositoryIcon from "../assets/images/repository_icon.svg";
import createApprovalIcon from "../assets/images/create_approval_icon.svg";
export const SidebarTabs = [
  {
    number: 1,
    title: "Ad Manager",
    bullet: true,
    subTexts: ["Facebook Ad Manage", "Google Ad Manage"],
    route: "/Ad-Manager",
    icon: (
      <svg
        className="w-6 h-6 text-gray-800 dark:text-white"
        aria-hidden="true"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        fill="none"
        viewBox="0 0 24 24"
      >
        <path
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M13.5 8H4m0-2v13a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V9a1 1 0 0 0-1-1h-5.032a1 1 0 0 1-.768-.36l-1.9-2.28a1 1 0 0 0-.768-.36H5a1 1 0 0 0-1 1Z"
        />
      </svg>
    ),
  },
];

export const sidebarItems = [
  {
    id: "dashboard",
    title: "Dashboard",
    icon: <img src={dashboardIcon} alt="Dashboard" width={16} height={16} />,
    link: "/dashboard",
    allowedRoles: [],
  },
  {
    id: "media",
    title: "Media",
    icon: (
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="black"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0)">
          <path d="M13.062 0H10.9453V24H13.062V0Z" fill="black" />
          <path d="M24 10.9453H0V13.062H24V10.9453Z" fill="black" />
          <path
            d="M19.7362 2.77163L2.76562 19.7422L4.26237 21.2389L21.2329 4.26837L19.7362 2.77163Z"
            fill="black"
          />
          <path
            d="M4.26237 2.76498L2.76562 4.26172L19.7362 21.2323L21.2329 19.7355L4.26237 2.76498Z"
            fill="black"
          />
        </g>
        <defs>
          <clipPath id="clip0">
            <rect width="24" height="24" fill="white" />
          </clipPath>
        </defs>
      </svg>
    ),
    link: "/media",
    prodIcon: true,
    allowedRoles: [],
  },
  {
    id: "adsManager",
    title: "Ads Manager",
    icon: <FaAd style={{ fontSize: "23px" }} />,
    link: "/Ad-Manager",
    subItems: [
      {
        title: "Manage Google Ad",
        icon: (
          <FaGoogle
            style={{ fontSize: "17px", position: "absolute", left: "16px" }}
          />
        ),
        link: "/Ad-Manager/Google-Ad-Manage",
      },
      {
        title: "Manage Facebook Ad",
        icon: (
          <FaFacebook
            style={{ fontSize: "17px", position: "absolute", left: "16px" }}
          />
        ),
        link: "/Ad-Manager/Facebook-Ad-Manage",
      },
    ],
    allowedRoles: [],
  },
  {
    id: "social_calendar",
    title: "Social Calendar",
    icon: <img src={repositoryIcon} alt="Dashboard" width={16} height={16} />,
    link: "/social_calendar",
    allowedRoles: [

    ],
  },
  {
    id: "repository",
    title: "Repository",
    icon: <img src={repositoryIcon} alt="Dashboard" width={16} height={16} />,
    // icon: <FaDatabase style={{ fontSize: "14px" }} />,
    link: "/repository",
    allowedRoles: [
      "zonal",
      "head_office",
      "regional_user",
      "franchise",
      "outlet",
      "agency_user",
      "agency_admin",
      "account_managers",
      "SuperAdmin"
    ],
  },
  {
    id: "creative_approval",
    title: "Creative Approval",
    icon: (
      <img src={createApprovalIcon} alt="Dashboard" width={16} height={16} />
    ),
    // icon: <LuImagePlus style={{ fontSize: "14px" }} />,
    link: "/creative_approval",
    allowedRoles: [
      "zonal",
      "head_office",
      "regional_user",
      "franchise",
      "outlet",
      "agency_user",
      "agency_admin",
      "account_managers",
      "SuperAdmin"
    ],
  },
];
export const categoryOptions = [
  { value: "AGL", label: "AGL" },
  { value: "Brands", label: "Brands" },
  { value: "Dealer", label: "Dealer" },
];
